<div class="modal-dialog cascading-modal modal-lg " role="document">
  <div class="modal-content">
    <div class="modal-header primary-color white-text">
      <h4 class="title">{{ Localization.LicenseAgreement | translate }}</h4>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="onSubmit()" #detailsForm="ngForm">
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="license" [innerHTML]="this.license$ | async">
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-3"
             data-cy="agreement">
          <mdb-checkbox (change)="onAgreeToTermsChange($event.checked)"
                        data-cy="agreesToLicenseCheckbox">
            {{Localization.IHaveReadAndAgreeToTheLicenseAgreementAbove | translate}}
          </mdb-checkbox>
        </div>
        <div class="d-flex justify-content-center mt-3 mb-2">
          <button type="submit" class="btn btn-amber" data-dismiss="modal" [disabled]="!agreedToTerms" mdbRippleRadius
                  mat-dialog-close>
            {{ Localization.GetStarted | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
